const { BASE_URL } = require("./client");

const GET_ALL_DETAILS = BASE_URL + "/startupShort/";
const DELETE_STARTUPSHORT = BASE_URL + "/startupShort/";
const DOWNLOAD_EXCEL_SHEET = BASE_URL + "/startupShort/download";

export { GET_ALL_DETAILS, DELETE_STARTUPSHORT, DOWNLOAD_EXCEL_SHEET };
